import { useState } from "react"
import { PaymentMethod } from "../../../types/payment"
import PaymentMethodList from "../../../common/ui/payment-management/payment-method-list"
import AddPaymentForm from "../../../common/ui/payment-management/add-payment-form"

interface PaymentMethodsSectionProps {
  paymentMethods: PaymentMethod[]
  orgId: string
  onRemove: (id: string) => Promise<void>
  onSetDefault: (id: string) => Promise<void>
  onUpdate: () => void
}

const PaymentMethodsSection = ({
  paymentMethods,
  orgId,
  onRemove,
  onSetDefault,
  onUpdate
}: PaymentMethodsSectionProps) => {
  const [showAddCard, setShowAddCard] = useState(false)

  return (
    <>
      {showAddCard ? (
        <AddPaymentForm
          orgId={orgId}
          onSuccess={() => {
            setShowAddCard(false)
            onUpdate()
          }}
          onCancel={() => setShowAddCard(false)}
        />
      ) : (
        <PaymentMethodList
          paymentMethods={paymentMethods}
          onRemove={onRemove}
          onSetDefault={onSetDefault}
        />
      )}
    </>
  )
}

export default PaymentMethodsSection
